const DEFAULT_REGIONS = ['Europe', 'Asia', 'Americas', 'Oceania']

function getDefaultFilters() {
  return {
    regions: [...DEFAULT_REGIONS],
    standards: [],
  }
}

export { getDefaultFilters, DEFAULT_REGIONS }
